const _0x2c5d = () => {
  const _0xc = ["L3K9", "VS6J", "PVX"];
  return _0xc.join("");
};

export const FC = _0x2c5d;
